(() => {
  function setStatus(form, message, type) {
    const container = form.closest('[role="dialog"]') || form;
    let status = container.querySelector('[data-consultation-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-consultation-status', '');
      status.className = 'premium-consultation-modal__status';
      form.insertAdjacentElement('beforebegin', status);
    }

    status.textContent = message;
    status.setAttribute('data-status-type', type);
  }

  function updateHiddenMessage(form) {
    const phoneInput = form.querySelector('input[type="tel"]');
    const emailInput = form.querySelector('input[type="email"]');
    const nameInput = form.querySelector('input[type="text"]');
    const messageInput = form.querySelector('[data-consultation-message]');

    if (!messageInput) return;

    const phone = phoneInput?.value?.trim();
    const email = emailInput?.value?.trim();
    const name = nameInput?.value?.trim();

    const lines = ['Book Consultation Request'];
    if (name) lines.push(`Name: ${name}`);
    if (email) lines.push(`Email: ${email}`);
    if (phone) lines.push(`Phone: ${phone}`);

    messageInput.value = lines.join('\n');
  }

  async function submitViaAjax(form) {
    updateHiddenMessage(form);

    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = submitButton && 'textContent' in submitButton ? submitButton.textContent : null;

    try {
      if (submitButton) {
        submitButton.disabled = true;
        if (originalText) submitButton.textContent = 'Submitting…';
      }

      setStatus(form, 'Submitting…', 'busy');

      const action = (form.getAttribute('action') || '/contact').split('#')[0];
      const formData = new FormData(form);

      const response = await fetch(action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });

      const responseText = await response.text();
      const doc = new DOMParser().parseFromString(responseText, 'text/html');

      const responseForm = doc.querySelector(`#${CSS.escape(form.id)}`);
      const hasErrors = !!responseForm?.querySelector('.errors, .form__message, .field--with-error, [aria-invalid="true"]');

      if (response.ok && !hasErrors) {
        setStatus(form, 'Thanks — we’ll reach out shortly.', 'success');
        form.reset();
        updateHiddenMessage(form);
        return;
      }

      setStatus(form, 'Please check your details and try again.', 'error');
    } catch (error) {
      console.error(error);
      setStatus(form, 'Something went wrong. Please try again.', 'error');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        if (originalText) submitButton.textContent = originalText;
      }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('[data-consultation-form]')) return;

    event.preventDefault();
    submitViaAjax(form);
  });
})();
